import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { channelService } from '@/services/channelService';

/**
 * Баннер-предупреждение: у пользователя нет подтверждённого канала уведомлений
 * (email/Telegram) — функционал ограничен (требование 3).
 *
 * Проверяет канал один раз при монтировании (после логина). Если канал появился —
 * баннер исчезает при следующем монтировании/обновлении.
 */
export function NotificationChannelBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let mounted = true;
    channelService
      .listChannels()
      .then((channels) => {
        if (!mounted) return;
        const hasVerified = channels.some(
          (c) => c.verified && c.channelType !== 'WEBSOCKET'
        );
        setShow(!hasVerified);
      })
      .catch(() => {
        // notification-сервис недоступен — баннер не показываем (не блокируем UI).
        if (mounted) setShow(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (!show) return null;

  return (
    <div className="mx-auto mb-4 flex items-center gap-3 rounded-md border border-amber-300 bg-amber-50 px-4 py-2 text-sm dark:bg-amber-950/30">
      <AlertTriangle className="h-4 w-4 text-amber-600" />
      <span>
        Нет подтверждённого канала уведомлений — функционал ограничен просмотром.
      </span>
      <Link to="/settings" className="ml-auto font-medium text-primary hover:underline">
        Привязать канал
      </Link>
    </div>
  );
}
